import { render, staticRenderFns } from "./MainAdBanner.vue?vue&type=template&id=bbd2b2be&scoped=true&"
import script from "./MainAdBanner.vue?vue&type=script&lang=js&"
export * from "./MainAdBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2b2be",
  null
  
)

export default component.exports